import create from "./amplify-service";

const path = "/translations";

const createTranslationService = (lang: string) => {
  return create(`${path}/${lang}`);
};

export default createTranslationService;
